import { lengthRequired } from '@polvo-labs/form-utils'
import Hidden from '../../components/Form/Fields/Hidden'
import TextArea from '../../components/Form/Fields/TextArea'
import FieldType from '../../components/Form/Fields/type'
import { emailRequiredValidation } from '../../utils/form-validations'

export interface ContactFormData {
  name: string
  email: string
  message: string
  recaptcha: string
  action: string
}

export type ContactForm = keyof ContactFormData

const fields: FieldType<ContactForm>[] = [
  {
    name: 'recaptcha',
    data: {
    },
    component: Hidden
  },
  {
    name: 'action',
    data: {
    },
    component: Hidden
  },
  {
    name: 'name',
    data: {
      icon: 'text',
      label: 'Nome completo',
    },
    html: {
      maxLength: 255,
      minLength: 6,
      placeholder: 'Nome e sobrenome',
    },
    size: 1 / 2,
    validation: lengthRequired({ min: 6, max: 255 }),
  },
  {
    name: 'email',
    data: {
      icon: 'mail',
      label: 'E-mail',
    },
    validation: emailRequiredValidation,
    html: {
      maxLength: 255,
      placeholder: 'nome@email.com',
    },
    size: 1 / 2,
  },
  {
    name: 'message',
    component: TextArea,
    data: {
      label: 'Mensagem',
      showCounter: true,
    },
    validation: lengthRequired({ min: 6, max: 1000 }),
    html: {
      maxLength: 1000,
      placeholder: 'Escreva sobre o que gostaria de falar com a gente',
    },
  },
]

export default fields
